import { render, staticRenderFns } from "./ThirdPartyServicesCard.vue?vue&type=template&id=2094230a&"
import script from "./ThirdPartyServicesCard.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyServicesCard.vue?vue&type=script&lang=js&"
import style0 from "./ThirdPartyServicesCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports